export const borderRadius = "8px";
